export default "__VITE_ASSET__60cb25d2__"